import cn from 'classnames'
import { TSeparatorProps } from './types'
import './styles.scss'

export const Separator = ({ vertical, className }: TSeparatorProps) => (
  <div className={cn('separator', className, { vertical })} />
)
